(() => {
  const WHEEL_ENDPOINT = '/apps/republic-rank/wheel';
  const SEGMENT_DEGREES = 45;
  const FULL_TURNS = 7;
  const SPIN_DURATION_MS = 3500;
  const S = window.cardRepublicStrings?.wheel || {};
  const locale = window.cardRepublicStrings?.locale || document.documentElement.lang || 'en';
  const isSk = String(locale).toLowerCase().startsWith('sk');
  const fallback = (sk, en) => isSk ? sk : en;
  const fmt = (value, vars = {}) => Object.entries(vars).reduce(
    (out, [key, replacement]) => String(out || '').replaceAll(`[${key}]`, String(replacement)),
    value || '',
  );
  const rewardCopy = (spin) => S.rewards?.[spin?.reward] || null;

  const formatDate = (isoOrDate) => {
    if (!isoOrDate) return '';

    const value = /^\d{4}-\d{2}-\d{2}$/.test(isoOrDate)
      ? new Date(`${isoOrDate}T12:00:00`)
      : new Date(isoOrDate);

    if (Number.isNaN(value.getTime())) return '';

    return new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(value);
  };

  const getLatestSpin = (payload) => {
    const spins = Array.isArray(payload?.spins) ? payload.spins : [];
    return spins.length ? spins[spins.length - 1] : null;
  };

  const initWheel = (root) => {
    if (!root || root.dataset.crWheelReady === 'true') return;
    root.dataset.crWheelReady = 'true';

    const disc = root.querySelector('[data-cr-wheel-disc]');
    const statusEl = root.querySelector('[data-cr-wheel-status]');
    const titleEl = root.querySelector('[data-cr-wheel-title]');
    const textEl = root.querySelector('[data-cr-wheel-text]');
    const button = root.querySelector('[data-cr-wheel-button]');
    const buttonText = root.querySelector('[data-cr-wheel-button-text]');
    const resultBox = root.querySelector('[data-cr-wheel-result]');
    const resultTitle = root.querySelector('[data-cr-wheel-result-title]');
    const resultText = root.querySelector('[data-cr-wheel-result-text]');
    const codeRow = root.querySelector('[data-cr-wheel-code-row]');
    const codeEl = root.querySelector('[data-cr-wheel-code]');
    const copyButton = root.querySelector('[data-cr-wheel-copy]');
    const rewardLink = root.querySelector('[data-cr-wheel-reward-link]');
    const weekEl = root.querySelector('[data-cr-wheel-week]');
    const drawEntriesEl = root.querySelector('[data-cr-wheel-draw-entries]');
    const mysteryEl = root.querySelector('[data-cr-wheel-mystery]');
    const segmentLabels = Array.from(root.querySelectorAll('.cr-wheel__segment-label'));

    if (!disc || !statusEl || !titleEl || !textEl || !button || !buttonText) return;

    const collectionUrl = root.dataset.collectionUrl || '#';
    const drawUrl = root.dataset.drawUrl || '#';
    const gearUrl = root.dataset.gearUrl || '#';
    const activeDrawMonthKey = root.dataset.drawMonthKey || '';
    const spinDuration = SPIN_DURATION_MS;

    let currentRotation = 0;
    let isSpinning = false;
    let lastPayload = null;
    let processingPollTimer = null;

    const setRootState = (state) => {
      root.classList.remove('is-loading', 'is-ready', 'is-extra', 'is-used', 'is-error', 'is-spinning');
      root.classList.add(state);
    };

    const setButton = ({ label, disabled = false }) => {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      buttonText.textContent = label;
    };

    const hideResult = () => {
      if (resultBox) resultBox.hidden = true;
      if (codeRow) codeRow.hidden = true;
      if (rewardLink) rewardLink.hidden = true;
    };

    const updateLabelOrientation = () => {
      const rotationModulo = ((currentRotation % 360) + 360) % 360;

      segmentLabels.forEach((label, index) => {
        const visualAngle = ((index * SEGMENT_DEGREES + rotationModulo) % 360 + 360) % 360;
        const shouldFlip = visualAngle > 90 && visualAngle < 270;
        label.classList.toggle('is-flipped', shouldFlip);
      });
    };

    const setDiscToSegment = (segmentIndex, animated = false) => {
      const index = Number(segmentIndex);
      if (!Number.isInteger(index) || index < 0 || index > 7) return;

      const targetModulo = (360 - index * SEGMENT_DEGREES) % 360;

      if (!animated) {
        currentRotation = targetModulo;
        disc.style.transition = 'none';
        disc.style.transform = `rotate(${currentRotation}deg)`;
        updateLabelOrientation();
        // Restore CSS transition after the browser has committed the static position.
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            disc.style.transition = '';
          });
        });
        return;
      }

      const currentModulo = ((currentRotation % 360) + 360) % 360;
      const delta = (targetModulo - currentModulo + 360) % 360;
      currentRotation += FULL_TURNS * 360 + delta;
      disc.style.transition = '';
      disc.style.transform = `rotate(${currentRotation}deg)`;
    };

    const setRewardLink = (spin) => {
      if (!rewardLink || !spin) return;

      let href = '';
      let label = '';

      if (['BASIC_BOOSTER', 'PREMIUM_BOOSTER', 'DOUBLE_BASIC'].includes(spin.reward)) {
  href = collectionUrl;
  label = S.openCollection || fallback('Otvoriť Collection →', 'Open Collection →');
} else if (spin.reward === 'DRAW_ENTRY') {
  // August Wheel Draw Entries are reserved for September, so don't link
  // to the still-active August Draw page. The link appears when the Hub
  // itself is switched to the same Draw month as the reward.
  if (!spin.drawMonthKey || !activeDrawMonthKey || spin.drawMonthKey === activeDrawMonthKey) {
    href = drawUrl;
    label = S.openDraw || fallback('Otvoriť Republic Draw →', 'Open Republic Draw →');
  }
} else if (spin.reward === 'GEAR_CHEST') {
  href = gearUrl;
  label = S.openGear || fallback('Otvoriť Republic Gear →', 'Open Republic Gear →');
}

      if (!href || href === '#') {
        rewardLink.hidden = true;
        return;
      }

      rewardLink.href = href;
      rewardLink.textContent = label;
      rewardLink.hidden = false;
    };

    const renderResult = (spin) => {
      if (!resultBox || !resultTitle || !resultText || !spin) return;

      const localizedReward = rewardCopy(spin);
      resultTitle.textContent = localizedReward?.title || spin.title || S.rewardFallback || 'Republic Wheel reward';

      let description = localizedReward?.copy || spin.description || '';
      if (spin.expiresAt) {
        const expiry = formatDate(spin.expiresAt);
        if (expiry) description += ` ${fmt(S.validUntil || 'Valid until [date].', { date: expiry })}`;
      }

      resultText.textContent = description;
      resultBox.hidden = false;

      if (codeRow && codeEl && spin.discountCode) {
        codeEl.textContent = spin.discountCode;
        codeRow.hidden = false;
      } else if (codeRow) {
        codeRow.hidden = true;
      }

      setRewardLink(spin);
    };

    const renderMeta = (payload) => {
      if (weekEl) {
        const next = formatDate(payload?.nextWeekKey);
        weekEl.textContent = next ? fmt(S.nextSpin || 'Next weekly spin: [date]', { date: next }) : (S.weeklyOnce || 'Once per week');
      }

      if (drawEntriesEl) {
        const count = Math.max(0, Number(payload?.drawBonusEntries || 0));
        drawEntriesEl.textContent = fmt(S.drawEntries || 'Bonus Draw entries: [count]', { count });
      }

      if (mysteryEl) {
        const count = Math.max(0, Number(payload?.pendingMysteryCards || 0));
        mysteryEl.hidden = count === 0;
        mysteryEl.textContent = count > 0 ? fmt(S.mysteryWaiting || fallback('Tajomná karta čaká: [count]', 'Mystery Card waiting: [count]'), { count }) : '';
      }
    };

    const renderStatus = (payload, { preserveResult = false } = {}) => {
      lastPayload = payload;
      renderMeta(payload);

      if (processingPollTimer) {
        window.clearTimeout(processingPollTimer);
        processingPollTimer = null;
      }

      const latest = getLatestSpin(payload);

      if (!preserveResult) {
        if (latest?.status === 'FULFILLED') {
          setDiscToSegment(latest.segmentIndex, false);
          renderResult(latest);
        } else {
          hideResult();
        }
      }

      if (payload?.hasProcessingSpin === true) {
        setRootState('is-loading');
        statusEl.textContent = S.processingStatus || 'PROCESSING';
        titleEl.textContent = S.processingTitle || 'Preparing your reward';
        textEl.textContent = S.processingCopy || '';
        setButton({ label: S.processingButton || 'PROCESSING…', disabled: true });
        processingPollTimer = window.setTimeout(async () => {
          try {
            const refreshed = await requestJson('GET');
            renderStatus(refreshed);
          } catch (_) {
            // Keep the current safe processing state. A page refresh can retry later.
          }
        }, 5000);
        return;
      }

      if (payload?.hasFailedSpin === true) {
        setRootState('is-error');
        statusEl.textContent = S.failedStatus || 'COMPLETE REWARD';
        titleEl.textContent = S.failedTitle || 'Your result is safely stored';
        textEl.textContent = S.failedCopy || '';
        setButton({ label: S.failedStatus || 'COMPLETE REWARD', disabled: false });
        return;
      }

      if (payload?.canWeeklySpin === true) {
        setRootState('is-ready');
        statusEl.textContent = S.readyStatus || '1 SPIN READY';
        titleEl.textContent = S.readyTitle || 'Your weekly spin is ready';
        textEl.textContent = S.readyCopy || '';
        setButton({ label: S.readyButton || 'SPIN THE WHEEL', disabled: false });
        return;
      }

      if (payload?.canExtraSpin === true) {
        setRootState('is-extra');
        statusEl.textContent = S.extraStatus || 'EXTRA SPIN';
        titleEl.textContent = S.extraTitle || 'You won another spin';
        textEl.textContent = S.extraCopy || '';
        setButton({ label: S.extraButton || 'SPIN AGAIN', disabled: false });
        return;
      }

      setRootState('is-used');
      statusEl.textContent = S.usedStatus || 'USED THIS WEEK';
      titleEl.textContent = S.usedTitle || 'Republic Wheel returns on Monday';
      textEl.textContent = S.usedCopy || '';
      setButton({ label: S.usedButton || 'NEXT SPIN ON MONDAY', disabled: true });
    };

    const requestJson = async (method) => {
      const response = await fetch(WHEEL_ENDPOINT, {
        method,
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          ...(method === 'POST' ? { 'Content-Type': 'application/json' } : {})
        },
        ...(method === 'POST' ? { body: '{}' } : {}),
        cache: 'no-store'
      });

      let payload = null;
      try {
        payload = await response.json();
      } catch (_) {
        payload = null;
      }

      if (!response.ok || payload?.success !== true) {
        const error = new Error(S.unavailable || 'Republic Wheel is currently unavailable.');
        error.code = payload?.code || 'WHEEL_REQUEST_FAILED';
        throw error;
      }

      return payload;
    };

    const loadStatus = async () => {
      setRootState('is-loading');
      statusEl.textContent = S.loadingStatus || 'LOADING';
      titleEl.textContent = S.checkingTitle || 'Checking your weekly spin…';
      textEl.textContent = S.checkingCopy || '';
      setButton({ label: `${S.loadingStatus || 'LOADING'}…`, disabled: true });

      try {
        const payload = await requestJson('GET');
        renderStatus(payload);
      } catch (error) {
        setRootState('is-error');
        statusEl.textContent = S.unavailableStatus || 'UNAVAILABLE';
        titleEl.textContent = S.loadFailedTitle || 'Republic Wheel could not be loaded';
        textEl.textContent = S.loadFailedCopy || '';
        setButton({ label: S.retry || 'TRY AGAIN', disabled: false });
        button.dataset.retryLoad = 'true';
      }
    };

    const spin = async () => {
      if (isSpinning) return;
      isSpinning = true;
      button.dataset.retryLoad = 'false';
      root.classList.add('is-spinning');
      statusEl.textContent = S.spinningStatus || 'SPINNING';
      setButton({ label: S.spinningButton || 'SPINNING…', disabled: true });
      hideResult();

      try {
        const payload = await requestJson('POST');
        const spinResult = payload?.spin;

        if (!spinResult || !Number.isInteger(Number(spinResult.segmentIndex))) {
          throw new Error(S.invalidResult || 'The server did not return a valid Republic Wheel result.');
        }

        setDiscToSegment(Number(spinResult.segmentIndex), true);

        window.setTimeout(() => {
          updateLabelOrientation();
          renderResult(spinResult);
          renderStatus(payload, { preserveResult: true });
          isSpinning = false;
          root.classList.remove('is-spinning');
        }, spinDuration + 80);
      } catch (error) {
        isSpinning = false;
        root.classList.remove('is-spinning');
        setRootState('is-error');
        statusEl.textContent = S.retry || 'TRY AGAIN';
        titleEl.textContent = S.spinFailedTitle || 'The spin could not be completed';
        textEl.textContent = S.spinFailedCopy || error?.message || '';
        setButton({ label: S.retry || 'TRY AGAIN', disabled: false });

        // Refresh the authoritative state. If the server already stored a reward,
        // the retry path will preserve it and never reroll it.
        window.setTimeout(async () => {
          try {
            const payload = await requestJson('GET');
            renderStatus(payload);
          } catch (_) {
            button.dataset.retryLoad = 'true';
          }
        }, 650);
      }
    };

    updateLabelOrientation();

    button.addEventListener('click', () => {
      if (button.disabled || isSpinning) return;

      if (button.dataset.retryLoad === 'true') {
        button.dataset.retryLoad = 'false';
        loadStatus();
        return;
      }

      spin();
    });

    if (copyButton && codeEl) {
      copyButton.addEventListener('click', async () => {
        const code = codeEl.textContent?.trim();
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
          const oldText = copyButton.textContent;
          copyButton.textContent = S.copied || 'COPIED ✓';
          window.setTimeout(() => {
            copyButton.textContent = oldText || S.copy || 'COPY CODE';
          }, 1600);
        } catch (_) {
          window.getSelection()?.selectAllChildren(codeEl);
        }
      });
    }

    loadStatus();
  };

  const boot = () => {
    document.querySelectorAll('[data-cr-wheel]').forEach(initWheel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
